/* eslint-disable */
export const trendUpIcon = {
  data: `<svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.1279 7L14.7482 14.3347C13.7506 15.3263 13.2517 15.822 12.633 15.822C12.0143 15.8219 11.5155 15.326 10.5181 14.3342L10.2788 14.0962C9.28047 13.1035 8.78131 12.6071 8.16215 12.6074C7.54299 12.6076 7.04419 13.1043 6.0466 14.0977L2.12793 18M22.1279 7V12.5458M22.1279 7H16.5458" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'trend-up' as const,
};
